import { useMediaQuery } from 'react-responsive';

export enum Viewports {
  MOBILE = 0,
  SMALL_MOBILE = 560,
  TABLET = 768,
  EXTRA_SMALL_DESKTOP = 1024,
  SMALL_DESKTOP = 1280,
  MEDIUM_DESKTOP = 1440,
  BIG_DESKTOP = 1920,
}

const viewportQueries = {
  [Viewports.MOBILE]: { minWidth: Viewports.TABLET },
  [Viewports.SMALL_MOBILE]: { minWidth: Viewports.SMALL_MOBILE },
  [Viewports.TABLET]: { minWidth: Viewports.TABLET },
  [Viewports.EXTRA_SMALL_DESKTOP]: { minWidth: Viewports.EXTRA_SMALL_DESKTOP },
  [Viewports.SMALL_DESKTOP]: { minWidth: Viewports.SMALL_DESKTOP },
  [Viewports.MEDIUM_DESKTOP]: { minWidth: Viewports.MEDIUM_DESKTOP },
  [Viewports.BIG_DESKTOP]: { minWidth: Viewports.BIG_DESKTOP },
};

const useIsViewport = (viewport: Viewports): boolean => {
  const query = viewportQueries[viewport];
  return useMediaQuery(query);
};

export { useIsViewport };
